import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import Question from './questions';
// import * as QuestionnaireActions from '../../actions/questionnaire_actions';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import { validate } from '../../validations';
import { ModalDialogCommon } from '../modal_dialog_common';


let AddMultipleQuestions = React.createClass({
    getInitialState() {
        return {
            showFollowAns: "show",
            ans: ''
        }
    },
    componentWillReceiveProps(nextProps) {

    },
    componentWillMount() {
        this.state.answer = _.extend({}, this.props.answer);
        if (this.state.answer.followQuestion && this.state.answer.followQuestion[0]) {
            if (this.state.answer.followQuestion[0].answerType.id.toString() === '7') {
                this.setState({
                    ans: this.state.answer.followQuestion[0].sliderConfiguration
                })
            } else {
                this.setState({
                    ans: this.state.answer.followQuestion[0].answer
                })
            }
        }
        if (this.props.editQuestion) {
            this.setState({
                showFollowAns: "show"
            })
        }
    },
    onChangeHandler(e) {
        var answer = _.extend({}, this.state.answer);
        answer.name = this.refs.answer.value;
        this.setState({
            answer: answer
        });
        if (this.props.onOptionChangeMulti) {
            this.props.onOptionChangeMulti(answer, this.props.id);
        }
        let value = e.target.value.trim();
        let isEmptyValue = validate.notEmpty(value);
        isEmptyValue ? e.target.className = 'update-mail' : e.target.parentElement.parentElement.className = 'error-border-bottom';
    },
    onfollowQuestion(e) {
        var answer = _.extend({}, this.state.answer);
        answer.followQuestion = [{ name: '', answerType: { id: '0' } }];
        this.setState({
            answer: answer
        });
        if (this.props.onOptionChangeMulti) {
            this.props.onOptionChangeMulti(answer, this.props.id);
        }
    },
    addQuestionsOptions(e) {
        if (e.target.value.trim().length === 140) {
            this.setState({ Okmessage: "Max 140 characters reached." });
            return false;
        }
        // this.refs.followAns.className = "show";
        var answer = _.extend({}, this.state.answer);
        answer.followQuestion[0].name = this.refs.followQuestions.value;
        answer.followQuestion[0].answerType = answer.followQuestion[0].answerType || { id: '1' };
        answer.followQuestion[0].answer = answer.followQuestion[0].answer || [];
        answer.followQuestion[0].sliderConfiguration = answer.followQuestion[0].sliderConfiguration || [];
        this.setState({
            answer: answer,
            showFollowAns: "show"
        });
        if (this.props.onOptionChangeMulti) {
            this.props.onOptionChangeMulti(answer, this.props.id);
        }

        e.target.value.trim().length > 0 ? e.target.className = 'follow-text' : e.target.className = 'follow-text error-border-bottom';
    },
    onFollowAnsChange(ansType, answerArr) {

        var answer = _.extend({}, this.state.answer);

        answer.followQuestion[0].answerType.id = ansType;

        if (answerArr && answerArr.length && ansType !== '7') {
            answer.followQuestion[0].answer = answerArr;
        }
        else if (answerArr && answerArr.length && ansType === '7') {

            answer.followQuestion[0].sliderConfiguration = answerArr;

        }
        else {
            delete answer.followQuestion[0].answer;
        }

        this.setState({
            answer: answer
        });
        if (this.props.onOptionChangeMulti) {
            this.props.onOptionChangeMulti(answer, this.props.id);
        }
    },
    deletRow(e) {
        if (this.props.onDelete) {
            this.props.onDelete(this.props.id);
        }
    },
    deletRowfollowQuestion(e) {
        var answer = _.extend({}, this.state.answer);
        delete answer.followQuestion;
        this.setState({
            answer: answer
        });
        if (this.props.onOptionChangeMulti) {
            this.props.onOptionChangeMulti(answer, this.props.id);
        }
    },
    remove_errorSupOptions(event) {
        event.target.parentElement.parentElement.className = '';
    },
    remove_errorFollowQuestion(event) {
        event.target.className = 'follow-text';
    },
    deletFollowAns() {
        this.refs.followAns.className = "hide";
        var answer = _.extend({}, this.state.answer);
        delete answer.followQuestion[0].answerType;
        delete answer.followQuestion[0].answer;
        this.setState({
            answer: answer
        });
        if (this.props.onOptionChangeMulti) {
            this.props.onOptionChangeMulti(this.refs.answer.value, this.props.id);
        }
    },

    isValidSubQuestion() {

        this.refs.answer.value.trim().length > 0 ? this.refs.answer.className = 'follow-text' : this.refs.answer.className = 'follow-text error-border-bottom';
        if (this.state.showFollowAns === 'show') {
            this.refs.followQuestions.value.trim().length > 0 ? this.refs.followQuestions.className = 'follow-text' : this.refs.followQuestions.className = 'follow-text error-border-bottom';
        }
    },
    maxCharacterValue() {
        if (this.refs.answer.value.length === 140) {
            this.setState({ Okmessage: "Max 140 characters reached." });
            return false;
        }
    },
    closebox() {
        this.setState({ Okmessage: null, });
    },

    render() {
        return (
            <div>
                <ul>
                    <li>
                        <button onClick={this.onfollowQuestion} className="icon-add-more"></button>
                      {this.props.optionCounter > 1 && <button onClick={this.deletRow} className="pull-right notification-close">X</button> }
                        <input className="update-mail" placeholder="Option" type='text' ref='answer' maxLength="140" onChange={this.maxCharacterValue} onBlur={this.onChangeHandler} onFocus={this.remove_errorSupOptions} defaultValue={this.state.answer.name}></input>
                    </li>
                </ul>
                {this.state.answer.followQuestion && this.state.answer.followQuestion[0] &&
                    <ul className="followup-question">
                        <li>
                            <span className='show'>
                                <button onClick={this.deletRowfollowQuestion} className="pull-right notification-close">X</button>

                                <input className="follow-text" placeholder="Follow Up Question" ref='followQuestions' maxLength="140" defaultValue={this.state.answer.followQuestion[0] && this.state.answer.followQuestion[0].name} type="text" onFocus={this.remove_errorFollowQuestion} onBlur={this.addQuestionsOptions} onChange={this.addQuestionsOptions} />
                            </span>
                            <span className={this.state.showFollowAns} ref={'followAns'} >
                                <li className="followup-question">
                                    <Question onFollowAnsChange={this.onFollowAnsChange} ans={this.state.ans} ansId={this.state.answer.followQuestion[0].answerType.id.toString()} />
                                </li>
                            </span>
                        </li>
                    </ul>
                }
                {this.state.Okmessage && <ModalDialogCommon message={this.state.Okmessage} action={this.closebox} />}
            </div>
        );
    }
});

let mapStateToProps = (state) => ({

});

let mapDispatchToProps = (dispatch) => ({
    // QuestionnaireActions: bindActionCreators(QuestionnaireActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(AddMultipleQuestions));



/** WEBPACK FOOTER **
 ** ./src/components/questionnaireScreen/addMultipleQuestions.js
 **/